import { mapActions, mapGetters, mapState } from "vuex";
import { pluralCount } from "@/helpers/helpers";
import { PERIOD } from "@/enums/period.enum";
import AnalyticsService from "@/services/analytics";
import { endpoints } from "@/config/endpoints";
const analyticsService = new AnalyticsService(endpoints.analytics.gmb);
import moment from "moment";
import { FORMAT } from "@/config/date-format";
export const categoryAnalyticsMixin = {
  data() {
    return {
      categorizationStatistics: null
    };
  },
  computed: {
    ...mapGetters("reviewsCategoriesAnalytics", [
      "getSelectedFacilityParams",
      "getSelectedFacilityMeta",
      "getFacilityParams",
      "getSelectedDate",
      "selectedFacility"
    ]),
    ...mapState("reviewsCategoriesAnalytics", [
      "selectedDate",
      "isComparing",
      "selectedFacility",
      "comparisonDate"
    ]),
    basicFilters() {
      return {
        ...this.getFacilityParams,
        ...this.getSelectedDate
      };
    },
    getCategorizationInProgressNumber() {
      if (!this.categorizationStatistics) return null;
      return this.categorizationStatistics.in_progress_count;
    },
    selectedFacilitiesDisplayName() {
      if (!this.getSelectedFacilityMeta.displayName)
        return this.$t("message.reviews.categories.allFacilities");
      if (
        this.getSelectedFacilityMeta.displayName &&
        this.getSelectedFacilityMeta.storeCode &&
        this.getSelectedFacilityMeta.address
      ) {
        return `${
          this.getSelectedFacilityMeta.displayName
        } <span class="separator">|</span> ${this.$t(
          "message.common.address"
        )} ${
          this.getSelectedFacilityMeta.address
        } <span class="separator">|</span> ${this.$t(
          "message.common.storeCode"
        )} ${this.getSelectedFacilityMeta.storeCode}`;
      }
      if (typeof this.getSelectedFacilityMeta.displayName !== "string") {
        return `${this.getSelectedFacilityMeta.displayName.gmbAddressName}<br /> <span class="grid-secondary-text">${this.getSelectedFacilityMeta.displayName.address}</span>`;
      } else {
        return this.getSelectedFacilityMeta.displayName;
      }
    }
  },
  methods: {
    ...mapActions("reviewsCategoriesAnalytics", [
      "setIsComparing",
      "setComparisonDate",
      "setSelectedDate",
      "setIsComparing",
      "setSelectedFacility",
      "clearSelectedFacility"
    ]),
    async fetchCategorizationStatistics() {
      this.categorizationStatistics = await analyticsService.getCategorizationStatistics(
        this.basicFilters
      );
    },
    setDefaultDate() {
      const startDate = moment(Date.now()).subtract(30, "days");
      const endDate = moment(Date.now());
      this.setSelectedDate({
        date_from: startDate.format(FORMAT.DATE),
        date_to: endDate.format(FORMAT.DATE)
      });
      this.$router.push({
        query: {
          ...this.$route.query,
          selectedFrom: this.selectedDate.date_from,
          selectedTo: this.selectedDate.date_to
        }
      });
    },
    getFacilitiesCountLabel(count) {
      return count > 0
        ? `(${pluralCount("message.pluralForms.facility", count)})`
        : "";
    },
    async initValues() {
      const { facility, facility_group, city, facilityGmb } = this.$route.query;
      if (facility || facility_group || city) {
        this.setSelectedFacility({
          tab: +this.$route.query.facility_tab,
          id: this.$route.query.facility,
          params: { facility, facilityGmb, facility_group, city },
          meta: {
            displayName: this.$route.query.displayName,
            address: this.$route.query.address,
            storeCode: this.$route.query.storeCode,
            quantity: this.$route.query.quantity
          }
        });
      }
      if (this.$route.query.selectedFrom && this.$route.query.selectedTo) {
        this.setSelectedDate({
          date_from: this.$route.query.selectedFrom,
          date_to: this.$route.query.selectedTo
        });
        if (
          this.$route.query.comparisonFrom &&
          this.$route.query.comparisonTo
        ) {
          this.setIsComparing(true);
          this.setComparisonDate({
            date_from: this.$route.query.comparisonFrom,
            date_to: this.$route.query.comparisonTo
          });
        }
      } else if (this.$route.query.dateType !== PERIOD.FULL) {
        this.setDefaultDate();
      }
    },
    handleDateChange({ date_from, date_to, comparison }) {
      this.setSelectedDate({ date_from, date_to });
      this.setComparisonDate(comparison);
    },
    async setFacilitySelectData(facility) {
      const queries = { ...this.$route.query };
      delete queries["categoryId"];
      delete queries["facility"];
      delete queries["facilityGmb"];
      delete queries["city"];
      delete queries["facility_group"];
      delete queries["withoutCategory"];
      this.reviewsListData = null;
      this.tab = null;
      const { params, meta, id, tab } = facility;
      this.$router.replace({
        query: {
          ...queries,
          ...params,
          ...meta,

          facility_tab: tab
        }
      });
      if (!id) {
        this.clearSelectedFacility();
        this.facilitiesDialog = false;
      }
      this.setSelectedFacility(facility);

      this.filterData(facility);
    },
    setDateChangeData(date_from, date_to, comparison, period_type) {
      const selectedDateValue =
        date_from && date_to ? { date_from, date_to } : null;
      const comparisonDateValue = comparison
        ? { date_from: comparison.date_from, date_to: comparison.date_to }
        : null;
      this.setSelectedDate(selectedDateValue);
      this.setComparisonDate(comparisonDateValue);
      const queries = { ...this.$route.query };
      if (!selectedDateValue) {
        delete queries.selectedFrom;
        delete queries.selectedTo;
      }
      if (!this.comparisonDate) {
        this.clearComparison();
        delete queries.compareOption;
        delete queries.comparisonFrom;
        delete queries.comparisonTo;
      }

      this.$router.push({
        query: {
          ...queries,
          ...(selectedDateValue && {
            selectedFrom: this.selectedDate.date_from,
            selectedTo: this.selectedDate.date_to
          }),
          ...(this.comparisonDate && {
            comparisonFrom: this.comparisonDate.date_from,
            comparisonTo: this.comparisonDate.date_to
          })
        }
      });
    }
  },
  created() {
    this.clearSelectedFacility();
  }
};
